import { OtpType } from '../../types';
import { api } from '../Api/api';

export interface GetPhonesResponse {
  phoneId: string;
  phoneNumber: string;
}

export interface SelectPhoneRequest {
  phoneId: string;
  type?: string;
}

export interface SelectPhoneResponse {
  success: boolean;
  message?: string;
}

export interface VerifyCodeRequest {
  code: string;
  type: OtpType;
}

export interface VerifyCodeResponse {
  success: boolean;
  message?: string;
}

// Função para buscar telefones
export const getPhones = async (): Promise<GetPhonesResponse[]> => {
  try {
    const response = await api.get<GetPhonesResponse[]>('/auth/phones');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar telefones:', error);
    throw error;
  }
};

// Função para selecionar telefone e enviar OTP
export const selectPhoneAndSendOtp = async (request: SelectPhoneRequest): Promise<SelectPhoneResponse> => {
  try {
    const response = await api.post<SelectPhoneResponse>('/auth/select-phone-and-send-otp', {
      phoneId: request.phoneId,
      type: request.type || OtpType.PHONE
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao selecionar telefone e enviar OTP:', error);
    throw error;
  }
};

// Função para verificar código de verificação
export const verifyCode = async (request: VerifyCodeRequest): Promise<VerifyCodeResponse> => {
  try {
    const response = await api.post<VerifyCodeResponse>('/auth/verify-otp', {
      code: request.code,
      type: request.type
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar código:', error);
    throw error;
  }
};

